import {ApolloError} from '@apollo/client';
import {GraphQLError} from 'graphql';
import {showError, showInfo} from '../ui/ToastNotification';

/**
 * Correctly handles Apollo error's
 * @param error {ApolloError} Error from the server
 * @param goBack {boolean} True if we should redirect user to the previous page
 */
export function handleError(error: ApolloError, goBack = false): void {
  error.graphQLErrors.map((x: GraphQLError) => showError(x.message));
  if (error.networkError) {
    showError(error.networkError.message);
  }
  if (goBack) {
    window.history.back();
  }
}

/**
 * Correctly handles successful form request
 * @param msg {string} Success message to show
 * @param redirect {string} If set, a user is redirected to this location
 */
export function handleSuccess(msg: string, redirect?: string): void {
  showInfo(msg);
  if (redirect) {
    setTimeout(() => {
      window.location.assign(redirect);
    }, 1500);
  }
}
